import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Assessment } from 'types/analysis-result.types';

interface Props {
  assessment: Assessment | undefined;
}

const DoComponent: React.FC<Props> = ({ assessment }) => {
  const { classes, cx } = useStyles();

  return (
    <Stack gap={1}>
      <div className={classes.card}>
        {assessment &&
          assessment.instructions?.descriptions?.['dos']?.map((item, index) => (
            <Stack key={index} className={classes.doItem}>
              <Stack direction={'row'} alignItems={'center'} gap={1.5} mb={'4px'}>
                <ThumbUpIcon className={cx(classes.icon, 'up')} />
                <Typography className={classes.text}>{item[0]}</Typography>
              </Stack>
              <Typography className={classes.subText}>{item[1]}</Typography>
            </Stack>
          ))}
      </div>
      <div className={classes.card}>
        {assessment &&
          assessment.instructions?.descriptions?.['donts']?.map((item, index) => (
            <Stack key={index} className={classes.doItem}>
              <Stack direction={'row'} alignItems={'center'} gap={1.5} mb={'4px'}>
                <ThumbDownIcon className={cx(classes.icon, 'down')} />
                <Typography className={classes.text}>{item[0]}</Typography>
              </Stack>
              <Typography className={classes.subText}>{item[1]}</Typography>
            </Stack>
          ))}
      </div>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    width: '100%',
    background: '#FFF',
    padding: '8px 16px',
    borderRadius: '8px',
  },
  doItem: {
    borderBottom: `1px solid ${theme.palette.greys.light}`,
    marginBottom: '8px',
    paddingBottom: '8px',
    '&:last-of-type': {
      borderBottom: 'none',
      marginBottom: 0,
      paddingBottom: 0,
    },
  },
  text: {
    fontSize: theme.typography.pxToRem(14),
  },
  subText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
  icon: {
    fontSize: theme.typography.pxToRem(24),
    color: theme.palette.greys.medium,
    '&.up': {
      color: theme.palette.success.main,
    },
    '&.down': {
      color: theme.palette.error.main,
    },
  },
}));

export default DoComponent;
